import { DisplayLocales, VoiceLocales } from '@shared/models/localization/Locales';

export const DefaultDisplayLocale: DisplayLocales = 'en';
export const DefaultVoiceLocale: VoiceLocales = 'en-us';
